import { render, staticRenderFns } from "./Authentication.vue?vue&type=template&id=3edd96d0&"
import script from "./Authentication.vue?vue&type=script&lang=ts&"
export * from "./Authentication.vue?vue&type=script&lang=ts&"
import style0 from "./Authentication.vue?vue&type=style&index=0&id=3edd96d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports